<template lang="pug">
	.clone-template-repository(v-if="showed")
		.card
			.card-header
				i.fa.fa-edit
				span Clone or update template repository
			.card-body.collapse.show
				.form-horizontal
					.form-group
						.one-setting-panel
							label.col-form-label
								span.title Code hosting
								select.custom-select.custom-select-sm(v-on:change="selectedHosting = $event.target.value")
									option(:selected="selectedHosting === 'bitbucket'" :value="'bitbucket'") BitBucket
									option(:selected="selectedHosting === 'gitflic'" :value="'gitflic'") Gitflic
						.one-setting-panel
							label.col-form-label
								span.title BitBucket repository name
								input.form-control(type="text" v-model="name" placeholder="team-name/repository-name")
						.one-setting-panel
							label.col-form-label
								span.title Branch name
								input.form-control(type="text" v-model="branch" placeholder="main")
						.form-result
							span git clone https://{{selectedHosting === 'bitbucket' ? 'bitbucket.org' : 'gitflic.ru/project'}}/{{transformedName}}.git -b {{branch}}
			.card-body.collapse.show
				.form-horizontal
					.form-actions
						button.btn.btn-warning(type="submit" v-on:click="clone()")
							i.fa.fa-trash
							| &nbsp;&nbsp;Clone template
						button.btn.btn-dark(type="button" v-on:click="close()") Close
</template>

<script>

	import Screen 				from './../../mixins/screen'

	export default {
		name: "CloneTemplateRepository",
		mixins: [Screen],
		screen: {
			events: {
				"Show CloneTemplateRepository": function() {

					this.showed = true;

				}
			}
		},
		data() {

			return {
				showed: false,
				name: 'mraid-io/<project-name>',
				branch: 'main',
				selectedHosting: 'bitbucket'
			};
		},
		computed: {
			transformedName() {

				return (this.name.indexOf('/') > -1) ? this.name : `mraid-io/${this.name}`;

			}
		},
		methods: {
			collectData() {


			},
			clone() {

				Server.sendToSocket({
					CloneTemplate: {
						hosting: this.selectedHosting,
						name: this.name,
						branch: this.branch,
						publisherId: Publisher.SelectedPublisher.id
					}
				});

				this.hide();

				Broadcast.call("Show MonitoringLog", ["clone-template"]);

			},
			close() {

				this.hide();

			}
		}
	}
</script>

<style lang="sass">

	.clone-template-repository
		position: absolute
		z-index: 2000
		left: 0
		top: 0
		right: 0
		bottom: 0
		background-color: rgba(0, 0, 0, 0.6)

		.form-result
			color: #8a93a2
			font-size: 11px
			margin-top: 5px

		.card
			width: 500px
			position: absolute
			left: 0
			right: 0
			top: 0
			bottom: 0
			margin: auto
			display: flex
			height: 300px
			box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.8)

			.btn-warning
				color: #fff

			.btn-ghost-dark, .btn-dark
				float: right
				color: #fff

			.form-actions
				position: absolute
				right: 19px
				bottom: 20px
				width: calc(100% - 40px)

			.two-setting-panel
				display: flex
				flex-direction: row
				justify-content: space-between

			.col-form-label
				display: flex
				flex-direction: row
				line-height: 32px
				justify-content: space-between

				.title
					display: flex
					overflow: hidden
					text-overflow: ellipsis
					white-space: nowrap
					flex-direction: row
					align-items: baseline

					.icon-info
						color: #20a8d8
						margin-left: 5px
						font-size: 13px !important

				.form-control
					width: 250px

		.custom-select
			cursor: pointer
			color: #fff
			width: 250px
			background: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3e%3cpath fill='%23ffffff' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e") no-repeat right 0.75rem center/8px 10px
			background-color: #343b41
			border: 1px solid #23282c
			margin-top: 0
			float: none !important

			&.selected
				background-color: #4dbd74

</style>

